import React from 'react'
import PropTypes from 'prop-types'

const Tile = ({ children, width, height, selected, onSelectTile }) => {
	const styledSvg = {
		border: selected ? '2px solid black' : '1px dotted #666666'
	};

	return(
		<svg style={styledSvg} width={width} height={height} viewBox="0 0 200 200" onClick={() => onSelectTile()}>
			{children}
		</svg>
	)
}

Tile.defaultProps = {
	width: 100,
	height: 100,
}

export default Tile;


// WEBPACK FOOTER //
// ./src/components/mosaic/tile.jsx